import { useQuery } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import {
	type GetAgentByUidUidV2FetchResponse,
	getAgentByUidUidV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorDetailQuery = (id?: string) => {
	const { data, isLoading, isError } = useQuery({
		queryKey: AdvisorKeys.detail(id ?? ""),
		queryFn: processResponse<unknown, GetAgentByUidUidV2FetchResponse>(() =>
			getAgentByUidUidV2(id ?? ""),
		),
		enabled: Boolean(id),
	});

	return { data, isLoading, isError };
};
